import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
export const AncestorImageContainer = /*#__PURE__*/ memo((param)=>{
    let { backgroundColor, children } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: "-ml-0.5 mr-1 flex size-5 items-center justify-center rounded",
        style: {
            backgroundColor
        },
        children: children
    });
});
AncestorImageContainer.displayName = "AncestorImageContainer";
